import { composeContainers } from "@/utils/composeContainers";
import BlogPost from "./components/BlogPost/BlogPost";
import { BlogCategories } from "./components/BlogCategories";
import { ViewProps } from "./types";
import { withCategories } from "./containers/withCategories";
import { withData } from "./containers/withData";
import { withActions } from "./containers/withActions";
import { Pagination, WDataWrapper } from "@/components";

export default composeContainers<ViewProps>({
  containers: [withActions, withCategories, withData],
  component: ({
    categories,
    posts,
    loading,
    handlePostClick,
    paginationMeta,
    onNextPage,
    onPrevPage,
  }: ViewProps) => (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Blog</h1>

      <BlogCategories categories={categories} />

      <WDataWrapper isData isError={undefined} isLoading={loading}>
        <div className="grid md:grid-cols-2 gap-12">
          {posts?.map((post, key) => (
            <BlogPost {...post} key={key} handlePostClick={handlePostClick} />
          ))}
        </div>
      </WDataWrapper>

      {paginationMeta && (
        <div className="mt-8">
          <Pagination
            onNextPage={onNextPage}
            onPrevPage={onPrevPage}
            {...paginationMeta}
          />
        </div>
      )}
    </div>
  ),
});
